import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';  // 確保您已經設定了Vuetify插件

Vue.config.productionTip = false;

new Vue({
  vuetify,  // 加入 vuetify 到 Vue instance
  render: h => h(App),
}).$mount('#app');